@import '@hevoio/hevo-ui-toolkit/styles/variables';

// The switch itself: HdSwitchWrapper's track, so the shimmer occupies the same
// box rather than a bare line where a control will be.
$ssh-config-switch-width: 40px;
$ssh-config-switch-height: $spacer-24;
// Label and the sentence under it, which is the taller half of the row.
$ssh-config-label-height: 14px;
$ssh-config-description-height: 12px;

// Mirrors an HdSwitchWrapper row while the peering spec is still resolving:
// switch on the left, label and description stacked beside it. A single flat
// line was the wrong shape — the row it stands in for is two lines tall next
// to a pill, so the block still jumped when the real toggle replaced it.
.toggleRowShimmer {
  display: flex;
  align-items: flex-start;
  gap: $spacer-12;
}

.switchShimmer {
  flex: none;
  width: $ssh-config-switch-width;
  height: $ssh-config-switch-height;
  // Fully rounded, like the switch track.
  border-radius: $ssh-config-switch-height * 0.5;
}

.toggleTextShimmer {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: $spacer-8;
  // The label sits a touch below the top of the switch track.
  padding-top: $spacer-2;
}

.labelShimmer {
  width: 140px;
  height: $ssh-config-label-height;
  border-radius: $border-radius-4;
}

.descriptionShimmer {
  width: 100%;
  max-width: 420px;
  height: $ssh-config-description-height;
  border-radius: $border-radius-4;
}
